import React, { useState, useEffect, useRef, useCallback } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { format, parseISO } from 'date-fns'; // Importer date-fns pour le formatage
import { fr } from 'date-fns/locale'; //Importer la locale française
import moment from 'moment';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import 'react-quill/dist/quill.bubble.css'; // Importez le style bubble
import { FaPaperPlane, FaUserCircle, FaUserTie, FaTrashAlt, FaEdit } from 'react-icons/fa';
import { getAuthToken } from '../../authToken';

// Composant Commentaire
const Commentaire_admin = ({ formulaire_id, user_id }) => {
  const [comments, setComments] = useState([]);
  const [newComment, setNewComment] = useState("");
  const commentEndRef = useRef(null);  // Référence pour le dernier commentaire/notification
  const isAdmin = true;
  const produit = "Eligibilite"
  const notification_id = localStorage.getItem('notification_id');
  const [formulaireUserId, setFormulaireUserId] = useState();

  const modules = {
    toolbar: [
      [{ 'header': [1, 2, false] }], // En-têtes
      ['bold', 'italic', 'underline'], // Styles de texte
      ['link', 'image'], // Ajouter des liens et des images
      [{ 'list': 'ordered' }, { 'list': 'bullet' }], // Listes
      ['clean'] // Bouton pour effacer le format
      [{ 'align': [] }], // Alignement du texte
      ['link', 'image'], // Ajouter des liens et des images
      [{ 'list': 'ordered' }, { 'list': 'bullet' }], // Listes
    ],

    // toolbar: [
    //     [{ 'header': [1, 2, false] }], // En-têtes
    //     ['bold', 'italic', 'underline'], // Styles de texte
    //     [{ 'color': [] }, { 'background': [] }], // Couleur du texte et de l'arrière-plan
    //     [{ 'size': ['small', false, 'large', 'huge'] }], // Taille de la police
    //     [{ 'align': [] }], // Alignement du texte
    //     ['link', 'image'], // Ajouter des liens et des images
    //     [{ 'list': 'ordered' }, { 'list': 'bullet' }], // Listes
    //     ['blockquote'], // Citation
    //     [{ 'code-block': [] }], // Bloc de code
    //     ['clean'], // Bouton pour effacer le format
    //     ['undo', 'redo'] // Annuler et rétablir
    // ],
  };

  // Fonction pour charger les commentaires
  const fetchComments = useCallback(async () => {
    if (!formulaire_id) {
      console.log("formulaire_id pas encore disponible");
      return;  // Ne pas faire l'appel API tant que formulaire_id n'est pas disponible
    }
    try {
      const token = localStorage.getItem('access_token');

      const response = await fetch(`${process.env.REACT_APP_HOTE}/liste-modifications-commentaires/${formulaire_id}/`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
      });
      // const response = await fetch(`${process.env.REACT_APP_HOTE}/liste-modifications-commentaires/${formulaire_id}/`);
      const data = await response.json();
      setComments(data);
      console.log('liste coms', data);
    } catch (error) {
      console.error('Erreur lors de la récupération des commentaires', error);
    }
  }, [formulaire_id]);

  // Marquer une notification spécifique comme vue
  const marquerVu = useCallback(async () => {
    try {
      const token = localStorage.getItem('access_token');

      const response = await fetch(`${process.env.REACT_APP_HOTE}/marquer-vu/${notification_id}/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          is_admin: isAdmin,  // Passer isAdmin dans le corps de la requête
        }),
      });

      if (!response.ok) {
        throw new Error('Erreur lors de la requête');
      }

      const data = await response.json();
      console.log('Notification marquée comme vue :', data);
    } catch (error) {
      console.error('Erreur dans marquerVu:', error);
    }
  }, [notification_id, isAdmin]);

  // Marquer toutes les notifications d'un formulaire comme vues
  const marquerToutesVues = useCallback(async () => {
    if (!formulaire_id) {
      console.log("formulaire_id pas encore disponible");
      return;  // Ne pas faire l'appel API tant que formulaire_id n'est pas disponible
    }
    try {
      const token = localStorage.getItem('access_token');

      const response = await fetch(`${process.env.REACT_APP_HOTE}/marquer-toutes-vues-eligibilite/${formulaire_id}/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          is_admin: isAdmin,  // Passer isAdmin dans le corps de la requête
        }),
      });

      if (!response.ok) {
        throw new Error('Erreur lors de la requête');
      }

      const data = await response.json();
      console.log('Toutes les notifications marquées comme vues :', data);
    } catch (error) {
      console.error('Erreur dans marquerToutesVu:', error);
    }

    try {
      const token = localStorage.getItem('access_token');

      const response = await fetch(`${process.env.REACT_APP_HOTE}/marquer-toutes-vues/${formulaire_id}/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          is_admin: isAdmin,  // Passer isAdmin dans le corps de la requête
          produit: produit
        }),
      });

      if (!response.ok) {
        throw new Error('Erreur lors de la requête');
      }

      const data = await response.json();
      console.log('Toutes les notifications marquées comme vues :', data);
    } catch (error) {
      console.error('Erreur dans marquerToutesVu:', error);
    }
  }, [formulaire_id, isAdmin, produit]);

  // Charger les commentaires au montage du composant
  useEffect(() => {
    marquerVu();
    marquerToutesVues();
    // fetchFormUser();
    fetchComments();  // Appel de la fonction lors du montage du composant
  }, [fetchComments, marquerVu, marquerToutesVues]);

  // Fonction pour ajouter un nouveau commentaire
  const addNewComment = async () => {
    if (newComment.trim() !== "") {
      try {
        const token = localStorage.getItem('access_token');

        const response = await fetch(`${process.env.REACT_APP_HOTE}/ajouter-commentaire/${formulaire_id}/${user_id}/`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          },
          body: JSON.stringify({ description: newComment }),
        });
        const data = await response.json();
        console.log("Commentaire ajouté:", data.commentaire);

        // Réinitialiser le champ de saisie
        setNewComment("");

        // Recharger tous les commentaires depuis l'API après l'ajout du commentaire
        fetchComments();
      } catch (error) {
        console.error('Erreur lors de l\'ajout du commentaire', error);
      }
    }
  };

  // // Fonction pour formater la date
  // const getFormattedDate = (dateString) => {
  //   const date = moment(dateString);
  //   const today = moment().startOf('day');
  //   const yesterday = moment().subtract(1, 'days').startOf('day');

  //   const formattedTime = format(parseISO(dateString), 'HH:mm', { locale: fr }); // Format de l'heure

  //   if (date.isSame(today, 'day')) {
  //     return `Aujourd'hui à ${formattedTime}`;
  //   } else if (date.isSame(yesterday, 'day')) {
  //     return `Hier à ${formattedTime}`;
  //   } else {
  //     return format(parseISO(dateString), 'dd MMMM yyyy à HH:mm', { locale: fr });
  //   }
  // };

  // Fonction pour formater la date
  const getFormattedDate = (dateString) => {
    const date = moment(dateString);
    const today = moment().startOf('day');
    const yesterday = moment().subtract(1, 'days').startOf('day');

    // const formattedTime = format(parseISO(dateString), 'HH:mm', { locale: fr }); // Format de l'heure

    if (date.isSame(today, 'day')) {
      return `Aujourd'hui`;
    } else if (date.isSame(yesterday, 'day')) {
      return `Hier`;
    } else {
      return format(parseISO(dateString), 'dd MMMM yyyy', { locale: fr });
    }
  };

  // // Fonction pour scroller vers le dernier commentaire
  // const scrollerVersLeBas = () => {
  //   commentEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  // };

  // // Utiliser useEffect pour scroller à chaque mise à jour des commentaires
  // useEffect(() => {
  //   scrollerVersLeBas();  // Scroll automatique vers le bas à chaque fois que les commentaires changent
  // }, [comments]);

  const [showModal, setShowModal] = useState(false);
  const [selectedNotification, setSelectedNotification] = useState(null);

  const handleVoirChamps = (notificationMessage) => {
    setSelectedNotification(notificationMessage);
    setShowModal(true); // Affichez la modale
  };
  const handleClose = () => {
    setShowModal(false); // Fermez la modale 
    setSelectedNotification(null);
  };


  const [showModalModifierCom, setShowModalModifierCom] = useState(false);
  const [showModalSupprimerCom, setShowModalSupprimerCom] = useState(false);
  const [selectedCommentaireId, setSelectedCommentaireId] = useState(null);
  const [selectedCommentaireMessage, setSelectedCommentaireMessage] = useState(null);

  const modalModifierCommentaire = (id, commentaire) => {
    console.log("voici id coms", id);
    console.log("voici message coms", commentaire);
    setSelectedCommentaireId(id);
    setSelectedCommentaireMessage(commentaire);
    setShowModalModifierCom(true); // Affichez la modale
  }
  const modifierCommentaire = async () => {
    console.log("select id coms", selectedCommentaireId);
    console.log("select message coms", selectedCommentaireMessage);
    try {
      const token = localStorage.getItem('access_token');

      const response = await fetch(`${process.env.REACT_APP_HOTE}/modifier-commentaire/${selectedCommentaireId}/${user_id}/`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ description: selectedCommentaireMessage }),
      });
      const data = await response.json();
      console.log("Commentaire ajouté:", data.description);

      // Recharger tous les commentaires depuis l'API après l'ajout du commentaire
      fetchComments();
      setShowModalModifierCom(false); // Fermez la modale 
    } catch (error) {
      console.error('Erreur lors de l\'ajout du commentaire', error);
    }
  }
  const handleCloseModifierCom = () => {
    setShowModalModifierCom(false); // Fermez la modale 
    setSelectedCommentaireId(null);
    setSelectedCommentaireMessage(null);
  };

  const modalSupprimerCommentaire = (id, commentaire) => {
    console.log("voici id coms pour supprimer", id);
    console.log("voici message coms pour supprimer", commentaire);
    setSelectedCommentaireId(id);
    setSelectedCommentaireMessage(commentaire);
    setShowModalSupprimerCom(true); // Affichez la modale
  };
  const supprimerCommentaire = async () => {
    console.log("select id coms", selectedCommentaireId);
    console.log("select message coms", selectedCommentaireMessage);
    try {
      const token = localStorage.getItem('access_token');

      const response = await fetch(`${process.env.REACT_APP_HOTE}/supprimer-commentaire/${selectedCommentaireId}/${user_id}/`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ description: selectedCommentaireMessage }),
      });
      const data = await response.json();
      console.log("Commentaire ajouté:", data.description);

      // Recharger tous les commentaires depuis l'API après l'ajout du commentaire
      fetchComments();
      setShowModalSupprimerCom(false); // Fermez la modale 
    } catch (error) {
      console.error('Erreur lors de l\'ajout du commentaire', error);
    }
  }
  const handleCloseSupprimerCom = () => {
    setShowModalSupprimerCom(false); // Fermez la modale 
    setSelectedCommentaireId(null);
    setSelectedCommentaireMessage(null);
  };

  return (
    <div className="commentaire-container" style={{ justifyContent: "space-between", height: "100%" }}>
      {/* Liste des commentaires avec barre de défilement */}
      <div style={styles.commentListContainer}>
        {comments.length === 0 ? (
          <div>Aucun commentaire ou notification disponible.</div>
        ) : (
          // // Grouper les commentaires par date avant de les mapper
          // Object.entries(
          //   comments
          //     .filter((item) => !(item.action === "commente" && !item.commentaire))
          //     .reduce((groups, item) => {
          //       const dateKey = moment(item.date_action || item.date_commentaire).format("YYYY-MM-DD");
          //       if (!groups[dateKey]) groups[dateKey] = [];
          //       groups[dateKey].push(item);
          //       return groups;
          //     }, {})
          // )
          //   .reverse() // Réorganiser par date
          //   .map(([date, items]) => (
          //     <div key={date}>
          //       {/* Affichage de la date */}
          //       <div className="mt-1 mb-1" style={{ textAlign: "center", fontWeight: "bold", color: "#555" }}>
          //         {/* {moment(date).format("dddd DD MMMM YYYY")} */}
          //         {getFormattedDate(date)}
          //       </div>
          //       {/* Affichage des items de la date */}
          //       {items
          //         .reverse() // Pour que les derniers soient affichés en haut pour chaque date
          //         .map((item) => {
          //           const isNewComment = moment().diff(moment(item.date_commentaire), "minutes") < 5; // Considérer un commentaire comme nouveau s'il a moins de 5 minutes
          //           return (
          //             <div
          //               key={item.id}
          //               className="comment"
          //               style={{
          //                 ...item.notification_message ? styles.notification : styles.comment,
          //                 backgroundColor: isNewComment ? "#ffffff" : "#ffffff", // Couleur de fond différente pour les nouveaux commentaires
          //               }}
          //             >
          //               {/* Reste du rendu des notifications et commentaires */}
          //               {item.notification_message && item.action !== "commente" ? (


          // Grouper les commentaires par date avant de les mapper
          Object.entries(
            comments
              .filter((item) => !(item.action === "commente" && !item.commentaire))
              .reduce((groups, item) => {
                const dateKey = moment(item.date_action || item.date_commentaire).format("YYYY-MM-DD");
                if (!groups[dateKey]) groups[dateKey] = [];
                groups[dateKey].push(item);
                return groups;
              }, {})
          )
            .reverse() // Réorganiser par date
            .map(([date, items]) => (
              <div key={date}>
                {/* Affichage de la date */}
                <div className="mt-1 mb-1" style={{ textAlign: "center", fontWeight: "bold", color: "#555" }}>
                  {getFormattedDate(date)}
                </div>
                {/* Affichage des items de la date */}
                {items
                  .reverse() // Pour que les derniers soient affichés en haut pour chaque date
                  .map((item, index) => { // Utilisation de l'index local pour générer une clé unique
                    const uniqueKey = `${item.id}-${index}`; // Combiner id et index
                    const isNewComment = moment().diff(moment(item.date_commentaire), "minutes") < 5; // Considérer un commentaire comme nouveau s'il a moins de 5 minutes
                    return (
                      <div
                        key={uniqueKey} // Utiliser la clé unique ici
                        className="comment"
                        style={{
                          ...item.notification_message ? styles.notification : styles.comment,
                          backgroundColor: isNewComment ? "#ffffff" : "#ffffff", // Couleur de fond différente pour les nouveaux commentaires
                        }}
                      >
                        {/* Reste du rendu des notifications et commentaires */}
                        {item.notification_message && item.action !== "commente" ? (
                          <>
                            {item.action === "modifie" &&
                              item.notification_message !== "Le dossier d'Eligibilité a été resoumis sans modification." ? (
                              <div className="d-flex justify-content-end align-items-start">
                                <div
                                  className="pl-1 pr-1 mr-5 mb-1"
                                  style={{ backgroundColor: "#f5f5f5", borderRadius: "10px" }}
                                >
                                  <div className="d-flex justify-content-between align-items-center mt-1 mb-1">
                                    <span className="d-flex justify-center align-items-center">
                                      <FaUserCircle size={15} className="mr-1" />
                                      <strong>{item.utilisateur.nom} {item.utilisateur.prenoms}</strong>
                                    </span>
                                  </div>
                                  <div className="pb-1 ml-1">
                                    Le dossier d'Eligibilité a été modifié et est en attente d'approbation.
                                    <a
                                      onClick={() => handleVoirChamps(item.notification_message)}
                                      className="text-success"
                                    >
                                      Voir les champs modifiés
                                    </a>
                                  </div>
                                  <div className="d-flex justify-content-end align-items-end mb-1">
                                    <small>
                                      {format(parseISO(item.date_action), 'HH:mm', { locale: fr })}
                                    </small>
                                  </div>
                                </div>
                              </div>
                            ) : item.action === "soumis" ? (
                              <div className="d-flex justify-content-center align-items-center">
                                <div
                                  className="pl-1 pr-1 mb-1 text-center"
                                  style={{ backgroundColor: "#ffffff", borderRadius: "5px", border: "2px solid #e1e1e1" }}
                                >
                                  {/* <div className="d-flex justify-content-between align-items-center mt-1 mb-1">
                                    <span className="d-flex justify-center align-items-center">
                                      <FaUserCircle size={15} className="mr-1" />
                                      <strong>{item.utilisateur.nom} {item.utilisateur.prenoms}</strong>
                                    </span>
                                  </div> */}
                                  {/* <div className="pb-1 ml-1">{item.notification_message}</div> */}
                                  <small>{item.notification_message}</small>
                                  <div className="d-flex justify-content-end align-items-end mb-1">
                                    <small>
                                      {format(parseISO(item.date_action), 'HH:mm', { locale: fr })}
                                    </small>
                                  </div>
                                </div>
                              </div>
                            ) : item.action === "a revoir" ? (
                              <div className="d-flex justify-content-center align-items-center">
                                <div
                                  className="pl-1 pr-1 mb-1"
                                  style={{ backgroundColor: "#ffffff", borderRadius: "5px", border: "2px solid #e1e1e1" }}
                                >
                                  {/* <div className="d-flex justify-content-between align-items-center mt-1 mb-1">
                                    <span className="d-flex justify-center align-items-center">
                                      <FaUserTie size={15} className="mr-1" />
                                      <strong>{item.emetteur ? <span>{item.emetteur.nom} {item.emetteur.prenoms}</span> : "INOVACT"}</strong>
                                    </span>
                                  </div> */}
                                  {/* <div className="pb-1 ml-1 text-center">{item.notification_message}</div> */}
                                  <small>{item.notification_message}</small>
                                  <div className="d-flex justify-content-end align-items-end">
                                    <small>
                                      {format(parseISO(item.date_action), 'HH:mm', { locale: fr })}
                                    </small>
                                  </div>
                                </div>
                              </div>
                            ) : item.action === "valide" ? (
                              <div className="d-flex justify-content-center align-items-center">
                                <div
                                  className="pl-1 pr-1 mb-1"
                                  style={{ backgroundColor: "#ffffff", borderRadius: "5px", border: "2px solid #e1e1e1" }}
                                >
                                  {/* <div className="d-flex justify-content-between align-items-center mt-1 mb-1">
                                    <span className="d-flex justify-center align-items-center">
                                      <FaUserTie size={15} className="mr-1" />
                                      <strong>{item.emetteur ? <span>{item.emetteur.nom} {item.emetteur.prenoms}</span> : "INOVACT"}</strong>
                                    </span>
                                  </div> */}
                                  {/* <div className="pb-1 ml-1 text-center">{item.notification_message}</div> */}
                                  <small>{item.notification_message}</small>
                                  <div className="d-flex justify-content-end align-items-end">
                                    <small>
                                      {format(parseISO(item.date_action), 'HH:mm', { locale: fr })}
                                    </small>
                                  </div>
                                </div>
                              </div>
                            ) : (
                              // Autres conditions pour les notifications et commentaires
                              <div className="d-flex justify-content-start align-items-start">
                                <div
                                  className="pl-1 pr-1 mr-5 mb-1"
                                  style={{ backgroundColor: "#f5f5f5", borderRadius: "10px" }}
                                >
                                  <div className="d-flex justify-content-between align-items-center mt-1 mb-1">
                                    <span className="d-flex justify-center align-items-center">
                                      <FaUserCircle size={13} className="mr-1" />
                                      <strong>{item.utilisateur.nom} {item.utilisateur.prenoms}</strong>
                                    </span>
                                  </div>
                                  <div className="pb-1 ml-1">{item.notification_message}</div>
                                  <div className="d-flex justify-content-end align-items-end mb-1">
                                    <small>
                                      {format(parseISO(item.date_action), 'HH:mm', { locale: fr })}
                                    </small>
                                  </div>
                                </div>
                              </div>
                            )}
                          </>
                        ) : (
                          <>
                            {/* Affichage des commentaires */}
                            {item.commentaire && (
                              <div className="d-flex justify-content-end align-items-end">
                                <div
                                  className="pl-2 pr-1 ml-5 mb-1"
                                  style={{ backgroundColor: "#e0f7fa", borderRadius: "10px" }}
                                >
                                  <div className="d-flex justify-content-between align-items-center mt-1">
                                    <span className="d-flex justify-center align-items-center">
                                      <FaUserTie size={13} className="mr-1" />
                                      <strong>INOVACT ({item.utilisateur.nom} {item.utilisateur.prenoms})</strong>
                                    </span>
                                    <span className="d-flex justify-end align-items-end ml-1">
                                      <FaEdit
                                        className="text-success"
                                        onClick={() => modalModifierCommentaire(item.id, item.commentaire)}
                                        style={{ cursor: 'pointer', fontSize: '13px', marginLeft: 'auto' }}
                                      />
                                      <FaTrashAlt
                                        className="text-danger"
                                        onClick={() => modalSupprimerCommentaire(item.id, item.commentaire)}
                                        style={{ cursor: 'pointer', fontSize: '13px', marginLeft: 'auto' }}
                                      />
                                    </span>
                                  </div>
                                  <span dangerouslySetInnerHTML={{ __html: item.commentaire }}></span>
                                  <div className="d-flex justify-content-end align-items-end mb-1">
                                    <small>
                                      {format(parseISO(item.date_commentaire), 'HH:mm', { locale: fr })}
                                    </small>
                                  </div>
                                </div>
                              </div>
                            )}
                          </>
                        )}
                      </div>
                    );
                  })}
              </div>
            ))
        )}
        {/* Élément de fin pour déclencher le défilement */}
        <div ref={commentEndRef} />

        {/* Modale pour afficher les champs de modifications */}
        <Modal show={showModal} onHide={handleClose}>
          <Modal.Header>
            <Modal.Title>Champs modifiés</Modal.Title>
          </Modal.Header>
          <Modal.Body>{selectedNotification}</Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Fermer
            </Button>
          </Modal.Footer>
        </Modal>
        {/* Modale pour modifier commentaire */}
        <Modal show={showModalModifierCom} onHide={handleClose}>
          <Modal.Header>
            <Modal.Title>Modifier le commentaire</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {/* <div style={{ display: "flex", alignItems: "center"}}>
              <textarea
                value={selectedCommentaireMessage}
                onChange={(e) => setSelectedCommentaireMessage(e.target.value)}
                // placeholder="Ecrivez un commentaire"
                style={{ flexGrow: 1, marginRight: "10px", padding: "10px", borderRadius: "5px", border: "1px solid #ccc" }}
              ></textarea>
            </div> */}
            <div className="form-group" style={{ display: "flex", alignItems: "center" }}>
              <label className="control-label" htmlFor="summernote_modification_com"></label>
              <ReactQuill
                theme="snow"
                value={selectedCommentaireMessage}
                onChange={setSelectedCommentaireMessage}
                modules={modules} // Appliquez les modules personnalisés
              />
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="success" onClick={modifierCommentaire}>
              Modifier
            </Button>
            <Button variant="secondary" onClick={handleCloseModifierCom}>
              Annuler
            </Button>
          </Modal.Footer>
        </Modal>
        {/* Modale pour confirmer suppression commentaire */}
        <Modal show={showModalSupprimerCom} onHide={handleCloseModifierCom}>
          <Modal.Header>
            <Modal.Title>Supprimer le commentaire</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div>Êtes-vous sûr de vouloir supprimer de commentaire ?</div>
            <div>
              <span dangerouslySetInnerHTML={{ __html: selectedCommentaireMessage }}></span>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="danger" onClick={supprimerCommentaire}>
              Supprimer
            </Button>
            <Button variant="secondary" onClick={handleCloseSupprimerCom}>
              Annuler
            </Button>
          </Modal.Footer>
        </Modal>
      </div>

      {/* Zone de texte pour ajouter un commentaire */}
      <div className="form-group">
        {/* <input type="hidden" name="qcm_idFr" id="qcm_idFr" className="form-control" /> */}
        <label className="control-label" htmlFor="summernote_commentaire"></label>
        <ReactQuill
          theme="snow"
          value={newComment}
          onChange={setNewComment}
          modules={modules} // Appliquez les modules personnalisés
          placeholder="Ecrivez un commentaire"
        />
      </div>
      <button onClick={addNewComment} className="btn-success"
        style={{
          borderRadius: '50%',        // Bouton arrondi
          width: '40px',              // Largeur du bouton
          height: '40px',             // Hauteur du bouton
          padding: '0',               // Pas de padding
          border: 'none',             // Aucune bordure
          outline: 'none',            // Supprime la bordure de focus
          boxShadow: 'none',          // Pas d'ombre autour
          display: 'flex',            // Flex pour centrer l'icône
          justifyContent: 'center',   // Centrage horizontal
          alignItems: 'center',       // Centrage vertical
        }}
      >
        <FaPaperPlane style={{ color: '#fff', fontSize: '20px' }} />
      </button>
      {/* <div style={{ display: "flex", alignItems: "center", marginTop: "10px" }}>
        <textarea
          value={newComment}
          onChange={(e) => setNewComment(e.target.value)}
          placeholder="Ecrivez un commentaire"
          style={{ flexGrow: 1, marginRight: "10px", padding: "10px", borderRadius: "5px", border: "1px solid #ccc" }}
        ></textarea>
        <button onClick={addNewComment} className="btn-success"
          style={{
            borderRadius: '50%',        // Bouton arrondi
            width: '40px',              // Largeur du bouton
            height: '40px',             // Hauteur du bouton
            padding: '0',               // Pas de padding
            border: 'none',             // Aucune bordure
            outline: 'none',            // Supprime la bordure de focus
            boxShadow: 'none',          // Pas d'ombre autour
            display: 'flex',            // Flex pour centrer l'icône
            justifyContent: 'center',   // Centrage horizontal
            alignItems: 'center',       // Centrage vertical
          }}
        >
          <FaPaperPlane style={{ color: '#fff', fontSize: '20px' }} />
        </button>
      </div> */}
    </div>
  );
};

// Styles pour les notifications et les commentaires avec une barre de défilement
const styles = {
  commentListContainer: {
    maxHeight: '400px', // Hauteur maximale pour la zone des commentaires
    overflowY: 'auto',  // Activer le défilement vertical si le contenu dépasse la hauteur
  },
  notification: {
    // borderLeft: '5px solid #007bff',  // Bordure à gauche pour les notifications
    // Couleur de fond pour les notifications
    padding: '2px',
    // borderBottom: '1px solid #cfcfcf',
  },
  comment: {
    padding: '2px',
    // borderTop: '1px solid #cfcfcf',
  },
};

// Exporter le composant
export default Commentaire_admin;
